import React from "react";

/**
 * Render a string with every ampersand wrapped in the signature
 * Cormorant-italic-copper treatment (.exec-amp). Use for dynamic labels,
 * eyebrows, badges, and headings inside .exec-scope so the `&` is never plain.
 *
 * Returns the original string untouched when there is no ampersand, so it is
 * safe to use everywhere. NOTE: do not use inside a native <option> element,
 * which cannot contain markup.
 */
export function amp(text) {
  if (text == null) return text;
  const str = String(text);
  if (!str.includes("&")) return str;
  const parts = str.split("&");
  const out = [];
  parts.forEach((part, i) => {
    if (i > 0) {
      out.push(
        <span key={`amp-${i}`} className="exec-amp">
          &amp;
        </span>
      );
    }
    if (part) out.push(<React.Fragment key={`txt-${i}`}>{part}</React.Fragment>);
  });
  return out;
}
